// HACK: If consumers use `react-dnd@3`, react-dnd has no types and will fail their build.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { jsx as _jsx } from "react/jsx-runtime";
// This should never be accessed because the clientOffsets will be set since we're
// only reading them after checking monitor.isOver(), but it appeases typescript
const DefaultClientOffset = {
  x: 0,
  y: 0
};
const dragSpec = {
  beginDrag: ({
    columnNamespace,
    columnName,
    columnIndex
  }) => ({
    columnNamespace,
    columnName,
    columnIndex
  }),
  endDrag: ({
    columnNamespace,
    columnName,
    onColumnOrderChange
  }, monitor) => {
    if (!monitor.didDrop()) {
      return;
    }
    const dropResult = monitor.getDropResult();
    const targetName = dropResult.columnName;
    if (columnName !== targetName) {
      onColumnOrderChange({
        columnNamespace,
        columnName,
        nextIndex: dropResult.columnIndex
      });
    }
  }
};
const dragCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
});
const dropSpec = {
  drop: ({
    columnNamespace,
    columnName,
    columnIndex
  }) => ({
    columnNamespace,
    columnName,
    columnIndex
  })
};
const dropCollect = (connect, monitor) => {
  const isOver = monitor.isOver();
  const connectDropTarget = connect.dropTarget();
  if (!isOver) {
    return {
      connectDropTarget,
      draggedLeft: false,
      draggedRight: false
    };
  }
  const deltaX = (monitor.getInitialClientOffset() || DefaultClientOffset).x - (monitor.getClientOffset() || DefaultClientOffset).x;
  return {
    connectDropTarget,
    draggedLeft: deltaX > 0,
    draggedRight: deltaX < 0
  };
};
export const ContentComponentWithDnDLegacyWrapper = WrappedComponent => {
  // HACK: react-dnd wants a ref, but it doesn't seem necessary for it to actually
  // function. This silences the console warning.
  const WithForwardRef = /*#__PURE__*/forwardRef((props, __ref) => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props)));
  return DragSource('column', dragSpec, dragCollect)(DropTarget('column', dropSpec, dropCollect)(WithForwardRef));
};